const prefix = 'fasr';
const iconName = 'text-size';
const width = 640;
const height = 512;
const aliases = [];
const unicode = 'f894';
const svgPathData = 'M24 32H0V56v72 24H48V128 80H168l0 352H120 96v48h24H264h24V432H264 216l0-352H336v48 24h48V128 56 32H360 24zM336 224H312v24 48 24h48V296 272h96l0 160H424 400v48h24H536h24V432H536 504l0-160h88v24 24h48V296 248 224H616 336z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
